import type { AppRouteModule } from '/@/router/types'

import { LAYOUT } from '/@/router/constant'

import { PageStateEnum } from '@/router/types'

const dashboard: AppRouteModule[] = [
    {
        path: '/screenshow',
        name: 'screenshow',
        component: LAYOUT,
        meta: {
            title: '风险一张图',
            icon: 'bx:bx-home',
            ignoreAuth: true,
            hideChildrenInMenu: true,
        },
        redirect: '/screenshow/index',
        children: [
            {
                path: '/screenshow/index',
                name: 'screenshowbody',
                component: () => import('/@/views/screenshow/index.vue'),
                meta: {
                    title: '风险一张图',
                    hideLayout: true,
                    hideMenu: false, // autoFullScreen: true,
                },
            },
        ],
    },
    {
        path: '/warning',
        name: 'warning',
        component: LAYOUT,
        redirect: '/warning/index',
        meta: {
            title: '风险预警',
            icon: 'fluent:alert-24-filled',
            hideChildrenInMenu: true,
        },
        children: [
            {
                path: '/warning/index',
                name: 'warnbody',
                component: () => import('/@/views/warning/index.vue'),
                meta: {
                    title: '风险预警',
                    hideMenu: true,
                    hideBreadcrumb: true,
                    currentActiveMenu: '/warning/index',
                },
            },
        ],
    },
    {
        path: '/prevention',
        name: 'prevention',
        component: LAYOUT,
        meta: {
            title: '防控调度',
            icon: 'ic:baseline-assessment',
        },
        redirect: '/prevention/questmap',
        children: [
            {
                path: '/prevention/questmap',
                name: 'questmap',
                component: () => import('/@/views/prevention/questmap.vue'),
                meta: {
                    title: '调度地图',
                    state: PageStateEnum.PUBLISHED,
                },
            },
            {
                path: '/prevention/statistics',
                name: 'statistics',
                component: () => import('/@/views/prevention/statistics.vue'),
                meta: {
                    title: '调度统计',
                    state: PageStateEnum.PUBLISHED,
                },
            },
            // {
            //     path: '/prevention/list',
            //     name: 'preventionquestlist',
            //     component: () => import('/@/views/prevention/list.vue'),
            //     meta: {
            //         title: '任务调度列表',
            //         state: PageStateEnum.DEVELOPING,
            //     },
            // },
        ],
    },
    {
        path: '/forecast',
        name: 'forecast',
        component: LAYOUT,
        meta: {
            title: '影响预报',
            icon: 'fluent:weather-cloudy-20-filled',
        },
        redirect: '/forecast/rainstormEffect',
        children: [
            {
                path: '/forecast/rainstormEffect',
                name: 'rainstormEffect',
                component: () => import('../../../views/forecast/rainstormEffect_def.vue'),
                meta: {
                    title: '暴雨风险影响预报',
                    state: PageStateEnum.PUBLISHED,
                },
            },
            {
                path: '/forecast/questList',
                name: 'questList',
                component: () => import('/@/views/forecast/questList.vue'),
                meta: {
                    title: '天气公报',
                    state: PageStateEnum.PUBLISHED,
                },
            },
            {
                path: '/forecast/questMap',
                name: 'questMap',
                component: () => import('/@/views/forecast/questMap.vue'),
                meta: {
                    title: '精细化预报',
                    state: PageStateEnum.PUBLISHED,
                },
            },
            {
                path: '/forecast/questStatistics',
                name: 'questStatistics',
                component: () => import('/@/views/forecast/questStatistics.vue'),
                meta: {
                    title: '气象服务专题',
                    state: PageStateEnum.PUBLISHED,
                },
            },
        ],
    },
    {
        path: '/proof',
        name: 'proof',
        component: LAYOUT,
        redirect: '/proof/index',
        meta: {
            title: '气象证明',
            icon: 'quill:paper',
            hideChildrenInMenu: true,
        },
        children: [
            {
                path: '/proof/index',
                name: 'proofList',
                component: () => import('/@/views/proof/index.vue'),
                meta: {
                    title: '气象证明',
                    hideMenu: true,
                    hideBreadcrumb: true,
                    currentActiveMenu: '/proof/index',
                },
            },
        ],
    },
    {
        path: '/history',
        name: 'history',
        component: LAYOUT,
        redirect: '/history/index',
        meta: {
            title: '数据查询',
            icon: 'ic:outline-search',
        },
        children: [
            {
                path: '/history/index',
                name: 'meteor',
                component: () => import('/@/views/history/meteor.vue'),
                meta: {
                    title: '气象历史数据',
                    currentActiveMenu: '/history/index',
                },
            },
            {
                path: '/disaster/index',
                name: 'disaster',
                component: () => import('/@/views/history/disaster.vue'),
                meta: {
                    title: '承保灾害地图',
                },
            },
        ],
    },
]

export default dashboard
